import React from "react";
import styled from "styled-components";
import { BusinessPortalHeader, PortalCaption, PortalMetricCard, PortalMetricGrid, PortalMetricLabel, PortalMetricValue, PortalPageShell, PortalSectionTitle, PortalSurface, StandardModalActionButton } from "src/components";

const RenewalPage = styled(PortalPageShell)`
    max-width: 72rem;
    margin: 2rem auto;
`;
const RenewalContent = styled.div`
    padding: 1.25rem;
    @media (max-width: 760px) { padding: 1rem; }
`;
export const ButtonWrapper = styled.div`
    display: flex;
    justify-content: ${p => p.$alignRight ? "flex-end" : "flex-start"};
    margin-top: 1.5rem;
`;
export const AccessCodeWrapper = styled.div`display: flex; margin-top: 0.75rem;`;
export const AccessCodeBox = styled.code`
    display: inline-flex; padding: 0.8rem 1rem; background: #fff; border: 1px solid #95a6c8; border-radius: 8px; color: #171a22; font: 800 1rem Manrope, Helvetica, sans-serif; letter-spacing: 0.08em;
`;
export const ActivateButton = styled(StandardModalActionButton)`min-width: 11.5rem;`;

const LicenseActivation = ({
    employeeName,
    durationNiceString,
    currency,
    accessToken,
    onNext,
    basePrice,
    title,
    description,
    subscriptionTitle,
    subscriptionDescription,
    actionLabel,
    alignActionRight
}) => (
    <RenewalPage>
        <BusinessPortalHeader
            title={title || "Start Your Subscription"}
            description={description || `Welcome ${employeeName}. Complete your subscription to unlock the full app experience.`}
            maxWidth="72rem"
        />
        <PortalSurface padding="0" marginBottom="0">
            <RenewalContent>
                <section>
                    <PortalSectionTitle size="1.25rem">{subscriptionTitle || "Your subscription"}</PortalSectionTitle>
                    <PortalCaption margin="0.5rem 0 1.25rem">
                        {subscriptionDescription || "Your 12-month subscription includes unlimited access to tools, features, and content designed to keep you connected and supported throughout the year."}
                    </PortalCaption>
                    <PortalMetricGrid columns="3">
                        <PortalMetricCard minHeight="auto">
                            <PortalMetricLabel>Subscription price</PortalMetricLabel>
                            <PortalMetricValue size="1.5rem">${Number(basePrice).toFixed(2)} {currency}</PortalMetricValue>
                            <PortalCaption margin="0" size="0.75rem">Tax-inclusive. A processing fee will be applied at checkout.</PortalCaption>
                        </PortalMetricCard>
                        <PortalMetricCard minHeight="auto">
                            <PortalMetricLabel>License term</PortalMetricLabel>
                            <PortalMetricValue size="1.5rem">{durationNiceString}</PortalMetricValue>
                            <PortalCaption margin="0">License</PortalCaption>
                        </PortalMetricCard>
                        <PortalMetricCard minHeight="auto">
                            <PortalMetricLabel>Your App Access Code</PortalMetricLabel>
                            <PortalMetricValue size="1.5rem">{accessToken}</PortalMetricValue>
                            <PortalCaption margin="0">Keep this code ready for signing in to your app.</PortalCaption>
                        </PortalMetricCard>
                    </PortalMetricGrid>
                    <ButtonWrapper $alignRight={alignActionRight}>
                        <ActivateButton type="button" $variant="primary" onClick={onNext}>{actionLabel || "Proceed to Payment"}</ActivateButton>
                    </ButtonWrapper>
                </section>
            </RenewalContent>
        </PortalSurface>
    </RenewalPage>
);
export default LicenseActivation;
